import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiHeaderService } from 'src/app/core/services/api-header.service';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { CommonFunctions } from '../common-functions';
import { StorageService } from './storage.service';
@Injectable({
  providedIn: 'root'
})
export class CmsService {
  public server = environment.APIEndpoint;
  public urls: any = {
    secureCohortContent: this.server + 'api/cms/cohortcontent/v1/get',
    unsecureCohortContent: this.server + 'api/unsec/cms/cohortcontent/v1/get',
    dashboardSequence: this.server + 'api/unsec/sequence/getSequenceList/v1',
    blogsList: this.server + 'api/unsec/cms/blogs/v1/list',
    saveBlog: this.server + 'api/cms/blogs/v1/action',
    bannerdetail: this.server + 'api/unsec/cms/promotions/v1/get?promotionId=',
    productFeedabckRatingTags: this.server + 'api/unsec/cms/productFeedback/v1/get',
    getTierBenefits: this.server + 'api/cms/tierBenefits/v1/view',
    footerContent: this.server + 'api/unsec/cms/article/v1/get',
    legalSectionContent:this.server + 'api/unsec/cms/legalsection/v1/get'
  };
  constructor(private http: HttpClient, private apiHeader: ApiHeaderService,
    private commonFunction: CommonFunctions,
    private storageService:StorageService,
     private encryptDecryptService : EncryptDecryptService,) { }
  getCmsCohortContent(): any {
    if (this.storageService.getAccessToken() != null && localStorage.getItem('user_profile') != null) {
      let userInfo = JSON.parse(localStorage.getItem('user_profile'))
      let secHeaders = this.apiHeader.getSecureHeader();
      let tier = (userInfo.tier == '' || userInfo.tier == null) ? 'welcome' : this.encryptDecryptService.decryptData(userInfo.tier).toUpperCase();
      let stars = userInfo.currentStarBalance == null ? 0 : this.encryptDecryptService.decryptData(userInfo.currentStarBalance);
      return this.http.get(this.urls.secureCohortContent + '?tier=' + tier + '&stars=' + stars, { headers: secHeaders });
    } else {
      let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.unsecureCohortContent, { headers: unsecureHeaderData });
    }
  }
  getDashboardSequence(): Observable<any> {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let getSecureHeader = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.dashboardSequence, { headers: getSecureHeader });
    }else{
      let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.dashboardSequence, { headers: unsecureHeaderData });
    }
  }
  private homeSequenceCache$: Observable<any>;
  getHomeSeqCache() {
    if (!this.homeSequenceCache$) {
      this.homeSequenceCache$ = this.getDashboardSequence().pipe(
        shareReplay(1),
      );
    }
    return this.homeSequenceCache$;
  }
  getBlogs() {
    let login = this.commonFunction.verifyLoggedInUser();
    if (login) {
      let getSecureHeader = this.apiHeader.getSecureHeader();
      return this.http.get(this.urls.blogsList, { headers: getSecureHeader });
    }else{
      let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
      return this.http.get(this.urls.blogsList, { headers: unsecureHeaderData });
    }
  }
  getBannerDetail(id) {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.get(this.urls.bannerdetail + id, { headers: unsecureHeaderData });
  }
  private blogCache$: Observable<any>;
  getblogCache() {
    if (!this.blogCache$) {
      this.blogCache$ = this.getBlogs().pipe(
        shareReplay(1),
      );
    }
    return this.blogCache$;
  }
  saveUserBLog(requestData) {
    let secHeaders = this.apiHeader.getSecureHeader();
    return this.http.post(this.urls.saveBlog, requestData, { headers: secHeaders });
  }
  getFeedbackTags() {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeader();
    return this.http.get(this.urls.productFeedabckRatingTags, { headers: unsecureHeaderData });
  }
  getTierBenefitsData() {
    let secHeaders = this.apiHeader.getSecureHeader();
    let userData = JSON.parse(localStorage.getItem('user_profile'))
    return this.http.get(this.urls.getTierBenefits + '?tier=' + this.encryptDecryptService.decryptData(userData.tier).toUpperCase() + '&stars=' + this.encryptDecryptService.decryptData(userData.currentStarBalance), { headers: secHeaders });
  }
  getFooterContent() {
    let unsecureHeaderData = this.apiHeader.getUnSecureHeaderWithoutGuestToken();
    return this.http.get(this.urls.footerContent, { headers: unsecureHeaderData });
  }
  getHelpCenterLegalContent(){
    let unsecureHeaderData = this.apiHeader.getUnSecureHeaderWithoutGuestToken();
    return this.http.get(this.urls.legalSectionContent, { headers: unsecureHeaderData });
  }
}
